import { Box, Divider, Stack } from "@mui/material";
import { DistaInfoListBlock } from "@sista/dista-ui";
import { IdmClientContext } from "@sista/idm-client";
import { Organization } from "@sista/library-stasi";
import { ShowCode } from "@sista/service-codetables";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

export type OrganizationFindForm = {
  idNumber?: string;
};

export type OrganizationInfoContentProps = {
  organization: Organization;
};

export const OrganizationInfoContent = (
  props: OrganizationInfoContentProps
) => {
  const { t } = useTranslation("ucet");

  const today = useMemo(() => {
    return new Date();
  }, []);

  const { loggedAccount } = useContext(IdmClientContext);

  /* const legalFormCode: string = useMemo(() => {
    const legForm =
      (props.organization as any)._viewData?.rejstrik?.legalFormCode ??
      undefined;
    return legForm;
  }, [props.organization]); */

  return (
    <>
      <Stack direction="column" spacing={1}>
        <DistaInfoListBlock
          label={t("ucet.organization.info.title", "Základní informace")}
          infoListItems={[
            {
              primaryColumn: t(
                "ucet.organization.info.name",
                "Úřední název subjektu"
              ),
              secondaryColumn: props.organization.displayName,
            },
            {
              primaryColumn: t("ucet.organization.info.id", "ID organizace"),
              secondaryColumn: props.organization.id,
            },
            {
              primaryColumn: t("ucet.organization.info.idNumber", "IČ"),
              secondaryColumn: props.organization.idNumber,
            },
            {
              primaryColumn: t("ucet.organization.info.vatId", "DIČ"),
              secondaryColumn: props.organization.vatId,
            },
            {
              primaryColumn: t(
                "ucet.organization.info.legalForm",
                "Právní forma"
              ),
              secondaryColumn: props.organization.legalFormCode ? (
                <Box sx={{}}>
                  <ShowCode
                    codeTable="legalForm"
                    findCode={props.organization.legalFormCode}
                    dateOfVersion={today}
                    lang={
                      loggedAccount?.preferredLanguage === "en" ? "en" : "cs"
                    }
                  />
                </Box>
              ) : (
                "-"
              ),
            },
            {
              primaryColumn: t(
                "ucet.organization.info.idDataBox",
                "ID datové schránky"
              ),
              secondaryColumn: props.organization.idDataBox,
            },
          ]}
        ></DistaInfoListBlock>

        <Divider />
        <DistaInfoListBlock
          label={t("ucet.organization.info.officialAddress", "Sídlo")}
          infoListItems={
            props.organization.officialAddress?.district &&
            props.organization.officialAddress?.district ===
              props.organization.officialAddress?.city
              ? [
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.street",
                      "Ulice"
                    ),
                    secondaryColumn: `${props.organization.officialAddress?.street} ${props.organization.officialAddress?.streetNumber}`,
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.city",
                      "Město"
                    ),
                    secondaryColumn: props.organization.officialAddress?.city,
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.zip",
                      "PSČ"
                    ),
                    secondaryColumn: props.organization.officialAddress?.zip,
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.locality",
                      "Okres"
                    ),
                    secondaryColumn:
                      props.organization.officialAddress?.locality ?? "-",
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.region",
                      "Kraj"
                    ),
                    secondaryColumn:
                      props.organization.officialAddress?.region ?? "-",
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.state",
                      "Stát"
                    ),
                    secondaryColumn:
                      props.organization.officialAddress?.state ?? "-",
                  },
                ]
              : [
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.street",
                      "Ulice"
                    ),
                    secondaryColumn: `${props.organization.officialAddress?.street} ${props.organization.officialAddress?.streetNumber}`,
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.district",
                      "Část obce"
                    ),
                    secondaryColumn:
                      props.organization.officialAddress?.district,
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.city",
                      "Město"
                    ),
                    secondaryColumn: props.organization.officialAddress?.city,
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.zip",
                      "PSČ"
                    ),
                    secondaryColumn: props.organization.officialAddress?.zip,
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.locality",
                      "Okres"
                    ),
                    secondaryColumn:
                      props.organization.officialAddress?.locality ?? "-",
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.region",
                      "Kraj"
                    ),
                    secondaryColumn:
                      props.organization.officialAddress?.region ?? "-",
                  },
                  {
                    primaryColumn: t(
                      "ucet.organization.info.address.state",
                      "Stát"
                    ),
                    secondaryColumn:
                      props.organization.officialAddress?.state ?? "-",
                  },
                ]
          }
        ></DistaInfoListBlock>
      </Stack>
    </>
  );
};
